import { Site } from '../core/modules/sites/Site';

/**
 * Return the URL with the site, area, and custom tracking id.
 *
 * Exception: keep the URL placeholders for hawk-prefix and hawk-custom-tracking
 * when keepUrlPlaceholders is true.
 * This is for manual products in the FIE Console, indexed data,
 * and editorial links (e.g., in product blocks),
 * which will be rewritten by Widgets/Hawklinks client-side.
 */
export const getRewrittenUrl = ({
  url,
  site,
  social,
  customTrackingId,
  area,
  trackingArea,
  articleUrl,
  articleName,
  keepUrlPlaceholders = false,
}: {
  url: string;
  site: Site;
  social?: string;
  customTrackingId: string;
  area?: string;
  trackingArea?: string;
  articleUrl?: string;
  articleName?: string;
  keepUrlPlaceholders?: boolean;
}): string => {
  if (articleUrl) {
    url = url.replaceAll('hawk-article-url', encodeURIComponent(articleUrl));
  }

  if (articleName) {
    url = url.replaceAll('hawk-article-name', encodeURIComponent(articleName));
  }

  if (keepUrlPlaceholders) {
    return url;
  }

  const isSkimLink = url.includes('go.redirectingat.com');
  const separator = isSkimLink ? '_' : '-';

  const prefixArea = (trackingArea || area || 'zz').toLowerCase();
  const prefix = `${site.analyticsName}${social ?? ''}${separator}${prefixArea}`;

  return url
    .replaceAll('hawk-prefix', prefix)
    .replaceAll('hawk-custom-tracking', `${prefix}${separator}${customTrackingId}`);
};
